import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class ClientService {
  get id(): number | null {
    return window['CLIENT_ID'] || null;
  }
}
